import { useEffect, useState, useContext } from 'react';
import { useForm } from "react-hook-form";

import * as Regex from 'utils/validations';
import { checkListPassword } from 'core/dataCheckListPassword';
import { DataContext } from 'providers/data';
import { ParamsDataCustomerForEdit } from 'utils/typeServices';

import { Box, Typography } from '@mui/material';

import Input from 'components/views/form/Input';
import { ButtonOutlined, ButtonRectangle } from 'components/views/form/Button';

import CircleIcon from '@mui/icons-material/Circle';

type ParamsCustomerForEdit = {
    dataCustomerForEdit: ParamsDataCustomerForEdit;
}

const AccessData = ({ dataCustomerForEdit }: ParamsCustomerForEdit) => {
    const { register, setValue, watch } = useForm();
    const { handlePostEditCustomerAppAccess } = useContext(DataContext);

    const [isEditInfos, setIsEditInfos] = useState(false);

    const [isLoading, setIsLoading] = useState(false);
    const [isEnableBtn, setIsEnableBtn] = useState(false);
    const [errorPassword, setErrorPassword] = useState(false);

    const login = watch('login');
    const passwordNew = watch('passwordNew');
    const passwordNewConfirm = watch('passwordNewConfirm');

    const handleDefault = () => {
        setIsLoading(false);
        setIsEditInfos(false);
        setValue('login', dataCustomerForEdit.user.username);
        setValue('passwordNew', '');
        setValue('passwordNewConfirm', '');
    }

    const handlePostEditCustomerAppAccessState = () => {
        setIsLoading(true);
        if (passwordNew) {
            if (passwordNew !== passwordNewConfirm) {
                setIsLoading(false);
                setErrorPassword(true);
                return;
            }

            handlePostEditCustomerAppAccess({
                token: localStorage.getItem('token')!,
                body: {
                    username: login,
                    password: passwordNew,
                    confirmPassword: passwordNewConfirm
                }
            });
            return;
        }

        handlePostEditCustomerAppAccess({
            token: localStorage.getItem('token')!,
            body: { username: login }
        });
    }

    const handleValidateRequirementsPassword = (index: number) => {

        switch (index) {
            case 0:
                if ((passwordNew?.length > 5) && (passwordNew?.length < 16)) {
                    return 'secondary.main';
                } else {
                    return 'error.light';
                }

            case 1:
                if (passwordNew?.match(/[A-Z]/)) {
                    return 'secondary.main';
                } else {
                    return 'error.light';
                }

            case 2:
                if (passwordNew?.match(/[a-z]/)) {
                    return 'secondary.main';
                } else {
                    return 'error.light';
                }

            case 3:
                if (passwordNew?.match(/[0-9]/)) {
                    return 'secondary.main';
                } else {
                    return 'error.light';
                }

            case 4:
                if (passwordNew?.match(/\W|_/) && !passwordNew?.match(Regex.emoji)) {
                    return 'secondary.main';
                } else {
                    return 'error.light';
                }
        }
    }

    useEffect(() => {
        if (dataCustomerForEdit) {
            handleDefault();
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [dataCustomerForEdit]);

    useEffect(() => {
        if (login?.match(Regex.email)) {
            setIsEnableBtn(true);

            if (passwordNew) {
                if ((passwordNew?.length > 5) && (passwordNew?.length < 16) && passwordNew?.match(/[A-Z]/) && passwordNew?.match(/[a-z]/) && passwordNew?.match(/[0-9]/) && passwordNew?.match(/\W|_/)) {
                    setIsEnableBtn(true);
                } else {
                    setIsEnableBtn(false);
                }
            }

            if (passwordNew === passwordNewConfirm) {
                setErrorPassword(false);
            }
        } else {
            setIsEnableBtn(false);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [login, passwordNew, passwordNewConfirm]);

    return (
        <Box sx={{ width: '100%' }}>
            <Box sx={{ width: { xs: '100%', md: 'calc(50% - 1.5625rem)' } }}>
                <Input
                    name='login'
                    label='Login'
                    type='text'
                    placeholder={login}
                    disabled={!isEditInfos}
                    register={{ ...register("login", { required: true }) }} />
            </Box>
            <Box
                sx={{
                    display: 'flex',
                    maxWidth: '21rem',
                    margin: '-.8rem 0 1.1875rem',
                    'svg': {
                        width: '.5rem',
                        height: '.5rem',
                        margin: '1px .3rem 0 0',
                        'path': {
                            color: login?.match(Regex.email) ? 'secondary.main' : 'error.light'
                        }
                    }
                }}>
                <CircleIcon />
                <Typography variant="body2" color={!isEditInfos || login?.match(Regex.email) ? '#ABAEAE' : '#F00'} textAlign='start' lineHeight='.875rem'>
                    Seu login deve ser um e-mail.
                </Typography>
            </Box>

            <Box sx={{ display: 'flex', justifyContent: 'space-between', gap: { xs: '0', md: '3.125rem' }, flexDirection: { xs: 'column', md: 'row' } }}>
                <Input
                    name="passwordNew"
                    label='Nova Senha'
                    placeholder='***********'
                    type='password'
                    disabled={!isEditInfos}
                    register={{ ...register("passwordNew", { required: true }) }} />
                <Input
                    name="passwordNewConfirm"
                    label='Confirmar nova senha'
                    placeholder='***********'
                    disabled={!isEditInfos}
                    error={errorPassword ? { type: 'pattern' } : false}
                    textError='As senhas informadas devem ser iguais.'
                    type='password'
                    register={{ ...register("passwordNewConfirm", { required: true }) }}
                />
            </Box>

            <ul>
                {checkListPassword.map((value, index) => (
                    <li key={index}>
                        <Box
                            sx={{
                                display: 'flex',
                                marginBottom: '1rem',
                                'svg': {
                                    width: '.5rem',
                                    height: '.5rem',
                                    margin: '1px .3rem 0 0',
                                    'path': {
                                        color: handleValidateRequirementsPassword(index)
                                    }
                                }
                            }}>
                            <CircleIcon />
                            <Typography variant="body2" color='#ABAEAE' textAlign='start' lineHeight='.875rem'>
                                {value}
                            </Typography>
                        </Box>
                    </li>
                ))}
            </ul>

            <Box sx={{ display: 'flex', gap: '1rem', 'button': { height: '2.5rem', width: '100%', maxWidth: { xs: '100%', md: '15.06rem' } } }}>
                <ButtonOutlined name={isEditInfos ? 'CANCELAR' : 'Editar'} onClick={() => { handleDefault(); setIsEditInfos(!isEditInfos); }} />

                {isEditInfos &&
                    <ButtonRectangle name='SALVAR DADOS' disabled={!isEnableBtn} loadingBtn={isLoading} onClick={() => handlePostEditCustomerAppAccessState()} />
                }
            </Box>
        </Box>
    );
}

export default AccessData;